module.exports = __webpack_public_path__ + "assets/img/font1.048ec661.png";